import { DataRequirements } from '../data.requirements';
import * as i0 from "@angular/core";
import * as i1 from "../data.requirements";
export class GetLocalstorageUseCase {
    constructor(data) {
        this.data = data;
    }
    run(key) {
        return this.data.getLocalstorage(key);
    }
}
GetLocalstorageUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GetLocalstorageUseCase_Factory() { return new GetLocalstorageUseCase(i0.ɵɵinject(i1.DataRequirementsInjectionToken)); }, token: GetLocalstorageUseCase, providedIn: "root" });
